<div>


  <Header />

  <PuzzleSelector @size-changed="handleSizeChange" @index-changed="handleIndexChange" @load-puzzle="fetchSolution" />

  <!-- The Rules Popup -->
  <!-- <Rules /> -->

  <!-- Pistas -->
  <Hints :selectedSize="selectedSize" :hasdef2="hasdef2" :def2Empty="def2_empty" :hasLost="has_lost"
    :size="selectedSize" :hint1_is_disabled="hint1_is_disabled" :hint2_is_disabled="hint2_is_disabled"
    :hint3_is_disabled="hint3_is_disabled" @show-letter-type="showLetterType" @show-def-bis="showDefBis"
    @show-letter="showLetter" />


  <Grid v-if="dataLoaded" ref="grid" :gridData="guessGrid" :isDisabled="has_lost" @cell-input="onCellInput" />



  <!-- Lives, Win and Lose messages -->
  <div v-if="dataLoaded">
    <LivesDisplay :lives="lives" :totalLives="selectedSize" :hasLost="has_lost" />

    <WinMessage :isSolved="isSolved" />

    <LostMessage :hasLost="has_lost" :buttonText="messageLostButton" @toggle-solution="setLoserGrid" />
  </div>

  <!-- Definitions -->
  <Definitions v-if="dataLoaded" :definitionsHtml="displayHtml" />

  <!-- Help button -->
  <!-- <Rules /> -->

  <!-- <table>
      <tbody>
        <tr>
          <td
            v-for="index in "local"
            :key="index"
            :style="tdStyle"
          >
          index
          </td>
        </tr>
      </tbody>
    </table> -->

</div>
